/**
 * region for helpers*/
import dictionary from './validation/dictionary';
import typing from './typing';
import list from './list';
import dom from './dom';
import rules from './validation/rules';

class validation {

    static getValidators(table, field, particularValidations) {

        let validators = [];

        let ruleNames = [];
        if (table
            && field
            && dictionary[table]
            && dictionary[table][field]
            && dictionary[table][field].rules) {
            ruleNames = dictionary[table][field].rules;
        }

        if (particularValidations) {
            ruleNames = [...ruleNames, ...particularValidations.split(' ')]
        }

        if (ruleNames && ruleNames.length > 0) {
            validators = ruleNames.map(function (rule) {
                if (typing.isFunction(rule))
                    return rule;
                else
                    return rules[rule];
            });
        }

        return validators;
    }

    static getResultSimplifiedForField(validationResults) {
        for (let x = 0; x < validationResults.length; x++) {
            if (!validationResults[x].valid)
                return { valid: false, validation_text: validationResults[x].text };
        }
        return { valid: true };
    }

    static getFieldAlias(tableName, fieldName) {
        let alias = fieldName;
        if (dictionary[tableName]
            && dictionary[tableName][fieldName]
            && dictionary[tableName][fieldName].alias) {
            alias = dictionary[tableName][fieldName].alias;
        }
        return alias;
    }

    static getResultSimplifiedForRow(validationResults) {
        for (let x = 0; x < validationResults.length; x++) {
            if (validationResults[x].length > 0) {
                for (let y = 0; y < validationResults[x].length; y++) {
                    if (!validationResults[x][y].valid) {
                        return { valid: false };
                    }
                }
            }
        }
        return { valid: true };
    }

    static hasSpecificValidation(validators, validatorSearchName) {
        const specificValidation = list.filterOne(validators, x => x.name === validatorSearchName);
        return typing.isDefined(specificValidation);
    }

    static setFocusOnHighestInvalid() {
        const invalidControls = document.querySelectorAll('input.js-invalid-control,select.js-invalid-control');
        const highestInvalidControl = dom.getHighest(invalidControls);
        if (highestInvalidControl) {
            highestInvalidControl.focus();
        }
    }

    static validate(validableCollection, isValidCallback, isNotValidCallback) {
        const mappedValidation = validableCollection.map(
            function (validableControl) {
                return validableControl.validate();
            }
        );

        Promise.all(mappedValidation).then(
            validationResults => {
                if (validation.getResultSimplifiedForRow(validationResults).valid) {
                    if (isValidCallback) {
                        isValidCallback();
                    }
                } else {
                    validation.setFocusOnHighestInvalid();
                    if (isNotValidCallback) {
                        isNotValidCallback();
                    }
                }
            }
        );
    }

    static isCheckExistCategory(value) {
        return rules.IsCategoryExist(value)
    }
}

export default validation;